export default {
    props: {
        'item-key': {
            default: () => 'id',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            swipeX: 0,
            swipeY: 0,
            lastY: 0,
            lastX: 0,
            activeLeft: false,
            activeRight: false,
            addIntervalID: null,
            substractIntervalID: null,
        }
    },
    methods: {
        dragHandler(e) {
            if (this.disabled) return
            if (e.target.className !== 'controls-layer') return
            let { clientX, clientY } = e.touches[0]
            if (!this.lastX || this.lastX === 0) {
                this.lastX = clientX
                return
            }
            if (!this.lastY || this.lastY === 0) {
                this.lastY = clientY
                return
            }
            this.swipeX += clientX - this.lastX
            this.swipeY += clientY - this.lastY
            if (this.swipeX <= 0) {
                this.resetXPosition()
                return
            }
            if (this.swipeX >= 200) {
                this.emitDelete()
                return
            }
            this.lastX = clientX
        },
        endHandler(e) {
            if (this.disabled) return
            if (Math.abs(this.swipeX) < 20 && Math.abs(this.swipeY) < 20) {
                this.$emit('show')
            }
            this.resetXPosition()
            this.resetYPosition()
        },
        emitDelete() {
            this.$emit('delete', this['item-key'])
        },
        emitAdd(num = 1) {
            this.$emit('add', num)
        },
        emitSubstract(num = 1) {
            this.$emit('substract', num)
        },
        setAddInterval() {
            this.addIntervalID = setInterval(this.emitAdd, 150)
        },
        setSubstractInterval() {
            this.substractIntervalID = setInterval(this.emitSubstract, 150)
        },
        resetYPosition() {
            this.lastY = 0
            this.swipeY = 0
        },
        resetXPosition() {
            this.lastX = 0
            this.swipeX = 0
        },
        leftButtonStart(e) {
            this.prevent(e)
            this.activeLeft = true
            this.emitSubstract()
            this.setSubstractInterval()
        },
        leftButtonEnd(e) {
            this.prevent(e)
            this.buttonEnd('substractIntervalID', 'activeLeft')
        },
        rightButtonStart(e) {
            this.prevent(e)
            if (this.swipeX > 0) return
            this.activeRight = true
            this.emitAdd()
            this.setAddInterval()
        },
        rightButtonEnd(e) {
            this.prevent(e)
            this.buttonEnd('addIntervalID', 'activeRight')
        },
        buttonEnd(intervalID, show) {
            this[show] = false
            if (!this[intervalID]) return
            clearInterval(this[intervalID])
            this[intervalID] = null
        },
        prevent(e) {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()
        },
    },
    computed: {
        swipeStyle() {
            return {
                left: `${this.swipeX}px`,
            }
        },
        backgroundStyle() {
            return {
                opacity: 0.003 * this.swipeX,
            }
        },
    },
}
